import { render } from "./ChatAssistant.vue?vue&type=template&id=6003d0cc&scoped=true"
import script from "./ChatAssistant.js?vue&type=script&lang=js&external"
export * from "./ChatAssistant.js?vue&type=script&lang=js&external"

import "./ChatAssistant.vue?vue&type=style&index=0&id=6003d0cc&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6003d0cc"],['__file',"src/components/ChatWidget/ChatAssistant/ChatAssistant.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6003d0cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6003d0cc', __exports__)) {
    api.reload('6003d0cc', __exports__)
  }
  
  module.hot.accept("./ChatAssistant.vue?vue&type=template&id=6003d0cc&scoped=true", () => {
    api.rerender('6003d0cc', render)
  })

}


export default __exports__